<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="类型">
              <a-select placeholder="请选择" v-model="queryForm.bannerType">
                <a-select-option
                  v-for="(item, index) in typeList"
                  :key="index"
                  :value="item.value"
                >
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="标题">
              <a-input v-model="queryForm.title" placeholder="请输入标题" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="2" @click="batchDel">批量删除</a-menu-item>
          <a-menu-item key="1" @click="batchShelve('1')">批量上架</a-menu-item>
          <a-menu-item key="0" @click="batchShelve('0')">批量下架</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown>
    </div>

    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="bannerList"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <span slot="bigPicurl" slot-scope="record">
          <img
            :src="imgBaseUrl + record"
            alt=""
            style="width: 200px; height: 100px"
          />
        </span>
        <span slot="operation" slot-scope="text, record">
          <a href="javascript:;" @click="editBanner(record, record.id)">编辑</a>
          <a-divider type="vertical" />

          <a
            href="javascript:;"
            @click="onDelete(record.id)"
            :disabled="record.shelfStatus == 0 ? false : true"
          >
            删除
          </a>
          <a-divider type="vertical" />

          <a
            :disabled="record.isReview == 0 ? false : true"
            @click="auditBanner(record)"
            >审核</a
          >
        </span>
        <template slot="shelfStatus" slot-scope="text, record">
          <a-switch
            v-model="record.shelfStatus"
            :disabled="record.isReview == 1 ? false : true"
            checked-children="上架"
            un-checked-children="下架"
            @click="handleShelve(record)"
          />
        </template>
      </a-table>
    </div>

    <a-drawer
      :title="drawerTitle"
      placement="right"
      :visible="visible"
      :width="620"
      :destroyOnClose="true"
      @close="handleAdd"
    >
      <a-form-model
        ref="bannerRuleForm"
        :model="bannerForm"
        :rules="bannerRules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item
          label="banner分类："
          ref="typeId"
          prop="bannerType"
          :autoLink="false"
        >
          <a-select v-model="bannerForm.bannerType" placeholder="请选择">
            <a-select-option
              @click="chooseBannerType(item)"
              :value="item.value"
              v-for="(item, index) in typeList"
              :key="index"
            >
              {{ item.title }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <!-- 排序 -->
        <a-form-model-item label="排序：" prop="idx">
          <a-input-number :min="1" v-model="bannerForm.idx"></a-input-number>
        </a-form-model-item>
        <!-- 标题 -->
        <a-form-model-item label="banner标题：" prop="title">
          <a-input
            :max-length="50"
            placeholder="请输入banner标题,限制50个字"
            v-model="bannerForm.title"
          />
        </a-form-model-item>
        <!-- 跳转地址 -->
        <a-form-model-item label="链接地址：">
          <a-input
            v-model="bannerForm.hrefUrl"
            placeholder="请输入链接地址"
          ></a-input>
        </a-form-model-item>

        <a-form-model-item label="打开方式：">
          <a-radio-group v-model="bannerForm.openType" @change="openChange">
            <a-radio-button :value="0"> 当前窗口 </a-radio-button>
            <a-radio-button :value="1"> 新窗口 </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <!-- 上传图片 -->
        <a-form-model-item label="上传图片：" prop="bigPicurl">
          <UploadImage
            :imgUrl="bannerForm.bigPicurl"
            @handleFileList="handleFileList"
          />
        </a-form-model-item>
      </a-form-model>
      <div class="drawer-bootom-button">
        <a-popconfirm
          title="确定放弃编辑？"
          @confirm="handleAdd"
          okText="确定"
          cancelText="取消"
        >
          <a-button style="margin-right: 0.8rem">取消</a-button>
        </a-popconfirm>
        <a-button @click="addHandleOk" type="primary">提交</a-button>
      </div>
    </a-drawer>

    <!-- 单独一个banner审核 -->
    <a-modal
      v-model="checkVisible"
      title="审核"
      @cancel="checkVisible == false"
    >
      <template slot="footer">
        <a-button @click="checkHandleOk('2')">审核驳回</a-button>
        <a-button type="primary" @click="checkHandleOk('1')">审核通过</a-button>
      </template>
      <a-form-model
        :model="bannerForm"
        :rules="bannerRules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="banner分类：" prop="bannerType">
          <a-select :default-value="bannerForm.bannerType_dictText" disabled>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="排序：" prop="idx">
          <a-input disabled v-model="bannerForm.idx" />
        </a-form-model-item>
        <a-form-model-item label="banner标题：" prop="title">
          <a-input disabled v-model="bannerForm.title" />
        </a-form-model-item>
        <a-form-model-item label="链接地址：">
          <a-input disabled v-model="bannerForm.hrefUrl"></a-input>
        </a-form-model-item>

        <a-form-model-item label="打开方式：">
          <a-radio-group disabled v-model="bannerForm.openType">
            <a-radio-button :value="0"> 当前窗口 </a-radio-button>
            <a-radio-button :value="1"> 新窗口 </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="轮播图片:" prop="pic">
          <div class="img_item" style="margin: 10px 0">
            <img :src="bannerForm.bigPicurl" alt="" style="width: 60%" />
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>
<script>
import { ajaxGetDictItems } from '@/api/api';
import JImageUpload from '@/components/jeecg/JImageUpload';
import { getAction, postAction } from '@/api/manage';
import JDictSelectTag from '@/components/dict/JDictSelectTag';
import UploadImage from '@/components/common/UploadImage';
export default {
  name: 'bannerManage',
  data() {
    return {
      columns: [
        {
          ellipsis: true,
          align: 'center',
          title: '标题',
          dataIndex: 'title',
          width: 100,
        },
        {
          align: 'center',
          title: '图片',
          dataIndex: 'bigPicurl',
          key: 'bigPicurl',
          width: 200,
          scopedSlots: { customRender: 'bigPicurl' },
          // customRender: (value, row, index) => {
          //   const obj = {
          //     children: this.$createElement('span', {}, [
          //       this.$createElement('img'),
          //       process.env.VUE_APP_FILE_PATH + value,
          //     ]),
          //     attrs: {},
          //   };
          //   return obj;
          // },
        },
        {
          ellipsis: true,
          align: 'center',
          title: '类型',
          dataIndex: 'bannerType_dictText',
          width: 100,
        },
        {
          ellipsis: true,
          align: 'center',
          title: '排序',
          dataIndex: 'idx',
          key: 'idx',
          width: 80,
        },
        {
          ellipsis: true,
          align: 'center',
          title: '审核状态',
          dataIndex: 'isReview',
          key: 'isReview',
          width: 100,
          customRender: (text) => {
            if (text == 0) {
              return '未审核';
            } else if (text == 1) {
              return '审核成功';
            } else {
              return '审核驳回';
            }
          },
        },
        {
          ellipsis: true,
          align: 'center',
          title: '上架状态',
          dataIndex: 'shelfStatus',
          key: 'shelfStatus',
          width: 100,
          scopedSlots: {
            customRender: 'shelfStatus',
          },
        },
        {
          title: '操作',
          key: 'operation',
          align: 'center',
          width: 150,
          scopedSlots: {
            customRender: 'operation',
          },
        },
      ],
      url: {
        list: process.env.VUE_APP_CMS_CONTENT + '/cont/banner/list', //所有数据列表
        add: process.env.VUE_APP_CMS_CONTENT + '/cont/banner/save',
        delete: process.env.VUE_APP_CMS_CONTENT + '/cont/banner/del',
        deleteBatch: process.env.VUE_APP_CMS_CONTENT + '/cont/banner/delByIds',
        audit: process.env.VUE_APP_CMS_CONTENT + '/cont/banner/review', //审核
        shelveBatch:
          process.env.VUE_APP_CMS_CONTENT + '/cont/banner/updateByIds',

        setList: process.env.VUE_APP_CMS_CONTENT + '/cont/banner/setList',
        publishSetUrl:
          process.env.VUE_APP_CMS_CONTENT + '/cont/banner/publishSet',
        shelveBanner: process.env.VUE_APP_CMS_CONTENT + '/cont/banner/update',
      },
      queryForm: {
        bannerType: '',
        title: '',
      },
      bannerList: [],
      typeList: [],
      selectionRows: [],
      selectedRowKeys: [],
      loading: false,
      ipagination: {
        //分页参数
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      visible: false,
      bannerForm: {
        bannerType: '',
        idx: null,
        title: '',
        hrefUrl: '',
        openType: 0,
        bigPicurl: '',
        typeId: '',
        typeName: '',
      },
      bannerRules: {
        bannerType: [
          { required: true, message: 'banner分类不能为空', trigger: 'blur' },
        ],
        idx: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
        title: [
          { required: true, message: '标题不能为空,限制50字', trigger: 'blur' },
        ],
        bigPicurl: [
          { required: true, message: '图片不能为空', trigger: 'blur' },
        ],
      },
      labelCol: { span: 5 },
      wrapperCol: { span: 14 },
      drawerTitle: '新增',
      checkVisible: false,
      imgFile: {},
      imgBaseUrl: '',
    };
  },
  components: {
    JImageUpload,
    JDictSelectTag,
    UploadImage,
  },
  created() {
    this.getTypeList();
    this.getTableList();
    this.imgBaseUrl =
      window.location.hostname == 'localhost'
        ? process.env.VUE_APP_LOCAL_PATH + process.env.VUE_APP_FILE_PATH
        : process.env.VUE_APP_FILE_PATH;
  },
  methods: {
    //获取banner分类
    getTypeList() {
      let code = 'banner_type';
      ajaxGetDictItems(code, null).then((res) => {
        if (res.success) {
          this.typeList = res.result;
        }
      });
    },

    getTableList(params) {
      let param = params
        ? params
        : {
            ...this.queryForm,
            pageNo: 1,
            pageSize: 10,
          };
      this.loading = true;
      getAction(this.url.list, param).then((res) => {
        console.log('VUE_APP_LOCAL_PATH', process.env);
        this.loading = false;
        if (res.success) {
          this.bannerList =
            res.result && res.result.records ? res.result.records : [];
          this.ipagination.total = res.result.total;
          this.bannerList.forEach((item, index) => {
            item.shelfStatus = item.status == 1 ? true : false;
            item.key = index + 1;
          });

          console.log(this.bannerList, '++++++');
        }
      });
    },
    //搜索
    searchQuery() {
      let params = {
        bannerType: this.queryForm.bannerType,
        title: this.queryForm.title,
        pageNo: 1,
        pageSize: 10,
      };
      this.getTableList(params);
    },
    searchReset() {
      this.queryForm = {
        bannerType: '',
        title: '',
      };
      this.getTableList();
    },

    handleAdd() {
      this.visible = !this.visible;
      this.bannerForm = {
        bannerType: '',
        idx: null,
        title: '',
        hrefUrl: '',
        openType: 0,
        bigPicurl: '',
        typeId: '',
        typeName: '',
      };
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    //清空选中的数据
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //批量删除
    batchDel() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        let ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }

        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function () {
            that.loading = true;
            postAction(that.url.deleteBatch, { ids: ids })
              .then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.ipagination.pageNo = 1;
                  that.getTableList();
                  that.onClearSelected();
                } else {
                  that.$message.error(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          },
        });
      }
    },
    //批量审核或驳回
    batchAudit(opt) {
      var ids = '';
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      }
      for (var a = 0; a < this.selectionRows.length; a++) {
        if (this.selectionRows[a].isReview == '0') {
          ids += this.selectionRows[a].id + ',';
        }
      }
      if (ids.length <= 0) {
        this.$message.warning('请选择一条有效的记录！');
        return;
      }
      let params = {
        isReview: opt,
        ids,
      };
      var that = this;
      this.$confirm({
        title: '审核',
        content: '确定审核' + (opt == '1' ? '通过' : '驳回') + '?',
        onOk: function () {
          that.loading = true;
          postAction(that.url.auditBatch, params)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.getTableList();
                that.onClearSelected();
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        },
      });
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      this.ipagination = pagination;
      this.getTableList({
        pageNo: pagination.current,
        pageSize: pagination.pageSize,
      });
    },
    addHandleOk() {
      this.$refs.bannerRuleForm.validate((bool) => {
        if (!bool) return;
        let params = {
          ...this.bannerForm,
        };
        params.bigPicurl = this.imgFile;
        postAction(this.url.add, params).then((res) => {
          this.visible = false;
          if (res.success) {
            this.getTableList();
          } else {
            this.$message.error(res.message);
          }
          Object.keys(this.bannerForm).forEach(
            (key) => (this.bannerForm[key] = '')
          );
        });
      });
    },
    // 切换打开方式
    openChange(value) {
      this.bannerForm.openType = value.target.value;
    },
    chooseBannerType(item) {
      this.bannerForm.typeId = item.id;
      this.bannerForm.typeName = item.title;
      this.bannerForm.bannerType = item.value;
    },
    handleFileList(file) {
      this.imgFile = file.fileName;
      if (this.visible) {
        this.bannerForm.bigPicurl =
          window.location.hostname == 'localhost'
            ? process.env.VUE_APP_LOCAL_PATH +
              process.env.VUE_APP_FILE_PATH +
              file.fileName
            : process.env.VUE_APP_FILE_PATH + file.fileName;
      }
    },
    editBanner(record) {
      this.drawerTitle = '编辑';
      this.visible = true;

      this.$nextTick(() => {
        this.bannerForm = {
          ...this.bannerForm,
          ...record,
          bannerType: record.bannerType,
          idx: record.idx,
          title: record.title,
          hrefUrl: record.hrefUrl,
          openType: record.openType,
          bigPicurl:
            window.location.hostname == 'localhost'
              ? process.env.VUE_APP_LOCAL_PATH +
                process.env.VUE_APP_FILE_PATH +
                record.bigPicurl
              : process.env.VUE_APP_FILE_PATH + record.bigPicurl,
        };
        this.imgFile = record.bigPicurl;

        console.log(this.bannerForm);
      });
    },
    onDelete(id) {
      var that = this;
      this.$confirm({
        title: '确认删除',
        content: '是否删除选中数据?',
        onOk: function () {
          that.loading = true;
          postAction(that.url.delete, { id: id })
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.ipagination.pageNo = 1;
                that.getTableList();
                that.onClearSelected();
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        },
      });
    },
    auditBanner(record) {
      this.checkVisible = true;
      this.bannerForm = record;
    },
    // 点击审核通过或审核驳回时触发
    checkHandleOk(opt) {
      postAction(this.url.audit, { review: opt, id: this.bannerForm.id }).then(
        (res) => {
          if (res.success) {
            this.$message.success(res.message);
            this.getTableList();
          } else {
            this.$message.error(res.message);
          }
        }
      );
      this.checkVisible = false;
    },
    /** 批量上架下架操作*/
    batchShelve(opt) {
      //opt 1 上架 0 下架
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      }
      //status 0 已下架 1 已上架
      let index = '';
      if (opt == 1) {
        //上架 - 已审核&未上架
        index = this.selectionRows.findIndex(
          (item) => item.isReview == 1 && item.status == 0
        );
      } else {
        //下架 - 已审核&已上架
        index = this.selectionRows.findIndex(
          (item) => item.isReview == 1 && item.status == 1
        );
      }

      if (index < 0) {
        this.$message.warning('请选择一条有效的记录！');
        return;
      }
      let optStr = opt == '0' ? '下架' : '上架';
      var that = this;
      let params = {
        status: opt,
        ids: this.selectedRowKeys.join(','),
      };
      this.$confirm({
        title: '数据' + optStr,
        content: '确定' + optStr + '所选数据？',
        onOk: function () {
          that.loading = true;
          postAction(that.url.shelveBatch, params)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.getTableList();
                that.onClearSelected();
              } else {
                that.$message.error(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        },
      });
    },
    handleShelve(record) {
      console.log(record);
      let strOpen = '确定要上架所选数据?';
      let strClose = '确定要下架所选数据?';
      let data = {
        bannerList: [],
        type: '',
      };
      let status = '';
      if (record.shelfStatus) {
        status = 1;
      } else {
        status = 0;
      }
      let params = {
        status,
        id: record.id,
      };
      var that = this;
      this.$confirm({
        title: record.shelfStatus ? '数据上架' : '数据下架',
        content: record.shelfStatus ? strOpen : strClose,
        onOk() {
          data.type = record.shelfStatus ? '1' : '0';
          postAction(that.url.shelveBanner, params).then((res) => {
            if (res.success) {
              that.$message.success(res.message);
              that.getTableList();
            } else {
              that.$message.error(res.message);
              record.shelfStatus = !record.shelfStatus;
            }
          });
        },
        onCancel() {
          record.shelfStatus = !record.shelfStatus;
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.ant-radio-button-wrapper-disabled.ant-radio-button-wrapper-checked {
  color: #666;
}
.table-operator {
  margin-bottom: 8px;
}
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
